import Immutable from 'seamless-immutable';
import { AnyAction } from 'redux';
import { shouldLogAction, getActionLogType } from 'support/actionHelper';

import { LOG, TOGGLE_LOG_OVERLAY } from 'actions/log';

const INITIAL_STATE = Immutable({ logs: [], showOverlay: false });

let counter = 0;

export default (state = INITIAL_STATE, action: AnyAction) => {
  switch (action.type) {
    case TOGGLE_LOG_OVERLAY:
      return state.merge({ showOverlay: !state.showOverlay });
    case LOG:
      counter += 1;
      return shouldLogAction(action)
        ? state.merge({
            logs: [
              ...state.logs,
              {
                logType: getActionLogType(action),
                message:
                  action.type === LOG ? action.payload.message : action.type,
                time: new Date().toLocaleTimeString(),
                id: counter,
              },
            ],
          })
        : state;
    default:
      return state;
  }
};
